import {
    CommonRoutes,
} from 'app/enums/common.enums'
import SkyNetDomain, {
    getUrlsFromTableConfig,
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import useHasPermission from 'app/hooks/useHasPermission'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import ProformaInvoiceCreate from './ProformaInvoiceCreate'
import ProformaInvoiceUpdate from './ProformaInvoiceUpdate'
import ProformaInvoiceOverview from './ProformaInvoiceOverview'
import tableConfig from './ProformaInvoices.config'

const tableControls: TableControlTypes[] = [
    TableControlTypes.Search,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

export default function ProformaInvoices() {
    const createPermissions = useHasPermission(['proforma_rule_create'])
    const updatePermissions = useHasPermission(['proforma_rule_update'])

    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                label: 'Overview',
                url: CommonRoutes.Overview,
                Component: ProformaInvoiceOverview,
            },
            permission: true,
        },
        {
            tab: {
                label: 'Data Update',
                url: CommonRoutes.DataUpdate,
                Component: ProformaInvoiceUpdate,
            },
            permission: updatePermissions,
        },
    ])

    return (
        <SkyNetDomain
            actionComponents={{
                Create: createPermissions ? ProformaInvoiceCreate : undefined,
            }}
            name={tableConfig.name}
            sidebarTabs={tabs}
            tableConfig={tableConfig}
            defaultTab={CommonRoutes.Overview}
            subdomainUrls={getUrlsFromTableConfig(tableConfig)}
        >
            <SkyNetTable
                tableControls={tableControls}
                tableConfig={tableConfig}
            />
        </SkyNetDomain>
    )
}
